
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.83.47c-.88-.265-1.556 1.002 0 1.59a7.49 7.49 0 014.67 6.95c0 4.151-3.346 7.5-7.494 7.5a7.485 7.485 0 01-7.494-7.5 7.487 7.487 0 014.403-6.833c1.58-.615 1.11-1.983 0-1.61C2.476 1.835.012 5.136.012 9.01c0 4.962 4.035 9 8.994 9 4.96 0 8.994-4.038 8.994-9 0-3.974-2.59-7.35-6.17-8.539z","font-family":"sans-serif","opacity":".99","overflow":"visible","paint-order":"markers stroke fill"}})])
          )
        }
      }
    